module.exports = __webpack_public_path__ + "static/image/history/m/201908@3x.ver2_0_2.jpg?5377cf22";